import { render, staticRenderFns } from "./downmeal.vue?vue&type=template&id=4396011d&scoped=true&"
import script from "./downmeal.vue?vue&type=script&lang=js&"
export * from "./downmeal.vue?vue&type=script&lang=js&"
import style0 from "./downmeal.vue?vue&type=style&index=0&id=4396011d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396011d",
  null
  
)

export default component.exports